import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ad-error',
  templateUrl: './ad-error.component.html',
  styleUrls: ['./ad-error.component.scss']
})
export class AdErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
